import { render, staticRenderFns } from "./DeriveModal.vue?vue&type=template&id=2b019d70"
import script from "./DeriveModal.vue?vue&type=script&lang=js"
export * from "./DeriveModal.vue?vue&type=script&lang=js"
import style0 from "./DeriveModal.vue?vue&type=style&index=0&id=2b019d70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports